(function () {
  if (window.__LUMERISA_IMAGE_SPEED_V2__) return;
  window.__LUMERISA_IMAGE_SPEED_V2__ = true;

  function galleryRoot() {
    return (
      document.querySelector('product-info product-media-gallery') ||
      document.querySelector('product-info media-gallery') ||
      document.querySelector('product-media-gallery') ||
      document.querySelector('.product-media-gallery') ||
      document.querySelector('.product__media-wrapper') ||
      document.querySelector('[data-product-gallery]')
    );
  }

  function galleryImages() {
    var root = galleryRoot();
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('img.product-media__image'));
  }

  function setPriority(image, loading, priority) {
    if (!image) return;
    image.decoding = 'async';
    if (loading) image.loading = loading;
    try {
      image.fetchPriority = priority;
      image.setAttribute('fetchpriority', priority);
    } catch (error) {}
  }

  function enforceInitialPolicy() {
    var list = galleryImages();
    if (!list.length) return;
    setPriority(list[0], 'eager', 'high');
    for (var i = 1; i < list.length; i += 1) {
      setPriority(list[i], 'lazy', 'low');
    }
  }

  function warmImmediateNext() {
    var list = galleryImages();
    if (list.length < 2) return;
    setPriority(list[1], 'eager', 'high');
    if (list.length > 2) setPriority(list[2], 'lazy', 'low');
  }

  function onGalleryIntent(event) {
    var root = galleryRoot();
    if (!root || !root.contains(event.target)) return;
    warmImmediateNext();
  }

  document.addEventListener('pointerdown', onGalleryIntent, { passive: true });

  ['variant:change', 'product:variant-change', 'shopify:section:load'].forEach(function (name) {
    document.addEventListener(name, function () {
      window.setTimeout(enforceInitialPolicy, 60);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceInitialPolicy, { once: true });
  } else {
    enforceInitialPolicy();
  }
})();